export enum UsageReportViewMode {
  CHART = 'chart',
  TABLE = 'table',
}

export const UsageReportViewModeMap: Record<UsageReportViewMode, { icon: string }> = {
  chart: { icon: 'm_chart-graph' },
  table: { icon: 'm_table-spacing-small' },
};
